module.exports = __webpack_public_path__ + "static/media/powerSupply3.ea336035.svg";